<template>
  <section v-if="handedOver === false">
    <slot />
  </section>
  <section v-else-if="handedOver">
    <h3
      v-if="calculating"
      style="margin: 3rem auto; width: 280px; font-size: 3rem; font-weight: 600;"
    >
      網頁導向中...
    </h3>
    <div v-else style="margin: 15% auto; width: 980px; text-align: center;">
      <div style="font-size: 3rem; font-weight: 600;">
        <a
          v-if="url"
          :href="url"
          target="_blank"
          rel="noopener"
          @click="onLinkClick"
        >
          開啟後台 2.0 {{ urlTitle }}
        </a>
        <a v-else @click="redirectToAdmin2(page, title)">重新導向</a>
      </div>
      <div
        v-for="link in links"
        :key="link.page"
        style="margin-top: 1.5rem; font-size: 1.5rem;"
      >
        <a @click="redirectToAdmin2(link.page, link.title)">
          開啟後台 2.0 {{ link.title }}
        </a>
      </div>
    </div>
    <b-loading :active="calculating" :is-full-page="true" :can-cancel="false" />
  </section>
</template>

<script>
import notifyService from '@/services/notifyService'
import { openAdmin2 } from '@/utils/admin2'
import { GIFTS_API } from '@/utils/apis'

// 贈品專區交棒開關：關閉時照常顯示原頁面（slot），打開後改導向後台 2.0。
// 每次進頁面都重查，交棒當下已開著的分頁換頁後也會導向。
export default {
  name: 'GiftHandoverGate',
  props: {
    page: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    links: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      handedOver: null,
      calculating: false,
      url: '',
      urlTitle: ''
    }
  },
  watch: {
    // 同一頁只換 query 時元件不會重建，要自己重查
    $route(to, from) {
      if (to.name === from.name && !this.handedOver) {
        this.checkHandover()
      }
    }
  },
  created() {
    this.checkHandover()
  },
  methods: {
    async checkHandover() {
      try {
        // 查詢卡住不能拖住總務的操作，超時就當沒交棒
        const res = await this.axios.get(`${GIFTS_API}/handover-status`, {
          timeout: 5000
        })
        this.handedOver = res.data.data.handed_over === true
      } catch (e) {
        // 查不到就維持原頁面，寫入仍由後端的開關擋下
        this.handedOver = false
      }

      if (this.handedOver) {
        this.redirectToAdmin2(this.page, this.title)
      }
    },
    onLinkClick() {
      // token 只能用一次，點過就換回「重新導向」；延到下一個 task 才清，
      // 免得 Vue 先拿掉 href，瀏覽器就不導覽了
      setTimeout(() => {
        this.url = ''
      }, 0)
    },
    async redirectToAdmin2(page, title) {
      try {
        this.calculating = true

        // 進頁面時不是點擊觸發，分頁常被瀏覽器擋下；擋下時改顯示連結讓使用者點
        this.url = (await openAdmin2(this.axios, page)) || ''
        this.urlTitle = title
      } catch (e) {
        this.url = ''

        notifyService.fetch_error('jwt_token', e)
      } finally {
        this.calculating = false
      }
    }
  }
}
</script>
